import CardActions from '@mui/material/CardActions';
import { styled } from '@mui/material';

export const CardActonWrapper = styled(CardActions)({
  display: 'flex',
  alignItems: 'center',
});
